import apiClient from '../axiosInstance';
import { API_BASE_ADDRESS } from '../api';
import { getReferralCodeAction } from '../sagas/referralCode/referralCodeSaga';

// APIの住所を設定します。

const referralCodeService = (action: getReferralCodeAction): any => {
  const config = {
    params: { member_id: action.memberID },
  };
  return {
    getReferralCode: () => apiClient.get(`${API_BASE_ADDRESS}/mypage/code`, config),
  };
};

export default referralCodeService;
